export const E2E_EMAIL_SUFFIX = 'e2e-user@vogel-vogel.com';
export const E2E_ETHEREAL_EMAIL_SUFFIX = '@ethereal.email';
export const TRIAL_PERIOD_DAYS = -1;
export const INTERNAL_EMAIL_SUFFIX = '@vogel-vogel.com';
